export const toSnakeCase = (str) => {
  return str
    .replace(/([A-Z])/g, '_$1')
    .replace(/^_/, '')
    .toLowerCase();
};

export const fromSnakeCase = (str) => {
  return {
    toCamelCase: () => {
      return str.replace(/_\w/g, (match) => {
        return match.replace('_', '').toUpperCase();
      });
    },
  };
};

// Mirrors the Rails Array#to_sentence behavior, e.g.:
//   toSentence(["A", "B"])      => "A and B"
//   toSentence(["A", "B", "C"]) => "A, B, and C""
export const toSentence = (array) => {
  if (array.length === 0) {
    return '';
  }

  if (array.length === 1) {
    return array[0];
  }

  let sentence = array.slice(0, array.length - 1).join(', ');
  if (array.length > 2) {
    sentence += ',';
  }
  sentence += ' and ' + array.slice(-1);
  return sentence;
};
